import Creators from './actions';

export const { clearFilters, updateFilters, setIsClearingFilters } = Creators;

export const clearAllFilters = (conditions) => (dispatch) => Promise.resolve(dispatch(clearFilters(conditions)));
